export default __webpack_public_path__ + "static/media/P10014.1a9d6124.png";